var _templateObject;
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { Flex } from '@finect/tabular-core/Flex';
import { AppLink } from '@finect/tabular-core/AppLink';
import { ChevronRight } from '@finect/tabular-icons/chevronRight';
import { Link } from 'react-router-dom';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { dataLayer } from '@finect/front-gtm';
import { SectionAction } from '../SectionAction';
import { Label } from './Label';
var LinkContainer = styled.div.withConfig({
  displayName: "Footer__LinkContainer",
  componentId: "sc-y1out8-0"
})(["display:block;"]);
var Inner = styled(Flex).withConfig({
  displayName: "Footer__Inner",
  componentId: "sc-y1out8-1"
})(["margin-top:8px;", ""], minMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref) {
  var align = _ref.align;
  return align === 'right' ? 'justify-content: flex-end;' : '';
}));
var ActionsBlock = styled.div.withConfig({
  displayName: "Footer__ActionsBlock",
  componentId: "sc-y1out8-2"
})(["display:flex;margin-left:auto;"]);
export var Footer = function Footer(_ref2) {
  var link = _ref2.link,
    _ref2$linkAlign = _ref2.linkAlign,
    linkAlign = _ref2$linkAlign === void 0 ? 'left' : _ref2$linkAlign,
    onExpand = _ref2.onExpand,
    expandedActionText = _ref2.expandedActionText,
    _ref2$actions = _ref2.actions,
    actions = _ref2$actions === void 0 ? [] : _ref2$actions;
  var show = link || onExpand;
  if (!show) {
    return null;
  }
  var linkProps = link ? link.hasOwnProperty('type') && link.type === 'client' ? {
    to: link.href,
    as: Link
  } : {
    href: link.href,
    as: 'a'
  } : {};
  if (link && link.hasOwnProperty('title')) {
    linkProps.title = link.title;
  }
  return React.createElement(Inner, {
    align: linkAlign
  }, link ? React.createElement(LinkContainer, null, React.createElement(Label, null, React.createElement(AppLink, _extends({
    "data-fi-event": "section-footer"
  }, linkProps), link.text, React.createElement(ChevronRight, {
    size: "18px",
    strokeWidth: "3"
  })))) : null, actions && actions.length > 0 || onExpand ? React.createElement(ActionsBlock, null, actions.map(function (action, index) {
    return React.createElement(SectionAction, {
      key: "section-".concat(index),
      onClick: function onClick() {
        action.onAction();
        dataLayer({
          id: 'FiEvent',
          type: 'fiEvent',
          params: {
            category: 'Interaction',
            action: action.action
          }
        });
      },
      icon: action.icon,
      actionText: action.action
    });
  }), onExpand ? React.createElement(SectionAction, {
    onClick: onExpand,
    icon: "airPlay",
    actionText: expandedActionText
  }) : null) : null);
};